import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 32, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y, scale: 0.99 }}
      whileInView={{ opacity: 1, y: 0, scale: 1 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function ChapterHeading({ number, label, title, description, dark = false, align = "left" }) {
  const centered = align === "center";
  return (
    <div className={`mb-14 md:mb-20 ${centered ? "text-center" : ""}`}>
      <Reveal>
        <div className={`flex items-center gap-4 mb-6 ${centered ? "justify-center" : ""}`}>
          <span className={`font-display text-sm font-semibold tracking-[0.25em] ${dark ? "text-pink-400" : "text-accent"}`}>
            {number}
          </span>
          <span className={`h-px w-12 ${dark ? "bg-pink-400/50" : "bg-accent/50"}`} />
          <span className={`text-xs font-bold uppercase tracking-[0.25em] ${dark ? "text-slate-400" : "text-muted-foreground"}`}>
            {label}
          </span>
        </div>
      </Reveal>
      <Reveal delay={0.1}>
        <h2 className={`font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight max-w-3xl ${centered ? "mx-auto" : ""} ${dark ? "text-slate-50" : "text-foreground"}`}>
          {title}
        </h2>
      </Reveal>
      {description && (
        <Reveal delay={0.2}>
          <p className={`mt-6 text-base md:text-lg leading-relaxed max-w-2xl ${centered ? "mx-auto" : ""} ${dark ? "text-slate-400" : "text-muted-foreground"}`}>
            {description}
          </p>
        </Reveal>
      )}
    </div>
  );
}

export function MaskedLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "110%" }}
        animate={{ y: 0 }}
        transition={{ duration: 0.9, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
}
